import merge from 'lodash/merge';

import {
    RECEIVE_SLUG_INFO,
    RECEIVE_SLUG_ERROR,
    CLEAR_SLUG_ERROR,
    FETCH_SLUG_INFO,
    RECEIVE_ASYNC_COMPONENTS,
    UPDATE_COMPONENTS,
    UPDATE_SEO,
} from './page-actions';
/**
 * Store universal page defaults here
 * @type {Object}
 */
const DEFAULT_SLUG_INFO = {
    components: {
        productTab: {},
    },
    customFields: {},
    seo: {
        title: '',
        canonical: '',
        description: '',
        keywords: '',
        robots: false,
        hideCopyBlock: false,
        copyBlock: {},
        categories: [],
        tags: [],
    },
    asyncComponentsReceived: false,
    addOns: {},
    errors: [],
};
const SlugInfoReducer = (state = DEFAULT_SLUG_INFO, action) => {
    Object.freeze(state);
    const { components, mergeFunction } = action;
    switch (action.type) {
        case RECEIVE_SLUG_INFO:
            //merge with defaults
            return merge({ fetching: false }, DEFAULT_SLUG_INFO, action.slugInfo);
        case UPDATE_SEO:
            const { seo } = action;
            return mergeFunction && seo ? Object.assign({}, state, mergeFunction(state, seo)) : state;
        case RECEIVE_SLUG_ERROR:
            return merge({}, state, { error: 'slug not found' });
        case CLEAR_SLUG_ERROR:
            return merge({}, state, { error: null });
        case FETCH_SLUG_INFO:
            return merge({ fetching: true }, DEFAULT_SLUG_INFO);
        case RECEIVE_ASYNC_COMPONENTS:
            let { errors, nextQuery } = action;
            let { errors: existingErrors } = state;
            return merge({}, state, {
                components,
                nextQuery: nextQuery || null,
                errors: (existingErrors || []).concat(errors),
            });
        case UPDATE_COMPONENTS:
            return mergeFunction
                ? Object.assign({}, state, mergeFunction(state, components))
                : merge({}, state, { components });
        default:
            return state;
    }
};

export default SlugInfoReducer;
